<template>
  <v-menu
    :close-on-content-click="false"
    :nudge-width="100"
    offset-x
    open-delay="400"
    close-delay="200"
    transition="scale-transition"
    :open-on-hover="true"
    v-model="showMenu"
  >
    <template v-slot:activator="{ on, attrs }">
      <a v-bind="attrs" v-on="on">
        <div class="tw-bg-[#0003] tw-rounded-md tw-overflow-hidden">
          <v-img
            :class="`tw-flex tw-items-end ${game.saved ? 'tw-border-4 shadow tw-border-[#2b57fb]' : ''}`"
            :src="game.image"
            height="220"
          >
            <template v-slot:placeholder>
              <v-sheet>
                <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
              </v-sheet>
            </template>
            <div class="tw-text-white tw-text-sm py-2 tw-flex tw-justify-between tw-items-center">
              <div :class="`background-overlay tw-z-0 py-2  background-info`"></div>
              <div :class="`game-title tw-text-white tw-font-bold`">
                <div>{{ game.name }}</div>
                <div class="tw-font-thin">{{ game.provider }}</div>
              </div>

              <div
                v-if="!!game.saved"
                class="tw-absolute tw-top-2 tw-right-2 tw-bg-green-500 tw-rounded-full tw-px-4 tw-py-1 tw-text-xs"
              >
                Added to {{ game.game_type }}
              </div>
            </div>
          </v-img>
        </div>
      </a>
    </template>
    <v-card color="#031b41">
      <div class="tw-p-3">
        <div class="tw-text-xl tw-font-bold text-left">
          {{ game.name }}
        </div>
        <v-divider></v-divider>

        <ul class="text-left py-2 tw-list-disc">
          <li class="tw-text-sm">UUID : {{ game.uuid }}</li>
          <li class="tw-text-sm">Type : {{ game.type }}</li>
          <li class="tw-text-sm">Technology : {{ game.technology }}</li>
          <li class="tw-text-sm">Provider : {{ game.provider }}</li>
          <li class="tw-text-sm">Is Mobile : {{ game.is_mobile ? "Yes" : "No" }}</li>
          <li class="tw-text-sm">Has Tables : {{ game.has_tables ? "Yes" : "No" }}</li>
          <li class="tw-text-sm">Has Lobby : {{ game.has_lobby ? "Yes" : "No" }}</li>
          <li class="tw-text-sm">Has Free Spins : {{ game.has_freespins ? "Yes" : "No" }}</li>
          <li class="tw-text-sm">
            Free Spin Valid Until Full Day : {{ game.freespin_valid_until_full_day ? "Yes" : "No" }}
          </li>
        </ul>

        <v-divider></v-divider>
        <div class="tw-flex tw-items-end tw-justify-between tw-space-x-4">
          <div class="tw-flex tw-justify-end mt-2">
            <v-btn link target="_blank" @click="testPlay(game)" color="#3498db" small>
              <v-icon>mdi-play</v-icon>
              Test Game
            </v-btn>
          </div>
          <div>
            <div class="tw-flex tw-justify-end mt-2" v-if="!game.saved">
              <v-btn color="#D3AE37" small @click="saveGame('slots')">Add to Slots Game</v-btn>
            </div>
            <div class="tw-flex tw-justify-end mt-2" v-if="!game.saved">
              <v-btn color="#D3AE37" small @click="saveGame('live')">Add to Live Casino</v-btn>
            </div>
            <div class="tw-flex tw-justify-end mt-2" v-else>
              <v-btn color="#EE2C00" small @click="removeGame()">Remove this Game from {{ game.game_type }}</v-btn>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-menu>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: ["cgame"],
  data: () => ({
    game: {},
    showMenu: false,
  }),
  watch: {
    cgame() {
      this.game = this.cgame;
    },
    showMenu() {
      this.game = this.cgame;
    },
  },
  mounted() {
    this.game = this.cgame;
  },
  methods: {
    ...mapActions("game", ["saveGameToDb", "removeGameToDb"]),
    async saveGame(game_type) {
      const response = await this.saveGameToDb({ ...this.game, game_type });
      if (response.success) {
        this.$emit("onSave", { add: true, payload: this.game, game_type });
        this.$toast.success(`Game successfully added in ${game_type}`, {
          position: "bottom-right",
          timeout: 2815,
          closeOnClick: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: false,
          icon: true,
          rtl: false,
        });
        this.showMenu = false;
      }
    },
    async removeGame() {
      const response = await this.removeGameToDb(this.game);
      if (response.success) {
        this.$emit("onSave", { add: false, payload: this.game });
        this.$toast.success("Game removed successfully", {
          position: "bottom-right",
          timeout: 2815,
          closeOnClick: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: false,
          icon: true,
          rtl: false,
        });
        this.showMenu = false;
      }
    },
    testPlay(game) {
      const type = game.type != "slots" ? "real-live" : "real-slots";
      let routeData = this.$router.resolve({
        name: `CasinoTestPlayer`,
        params: { type },
        query: {
          id: game.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style scoped>
.background-overlay {
  @apply tw-text-white tw-text-sm  tw-flex  tw-justify-between  tw-items-center tw-transition-all tw-duration-500 tw-absolute tw-bottom-0 tw-h-12 tw-w-full;
}
.game-title {
  @apply tw-antialiased tw-pb-1 tw-opacity-100 tw-text-left tw-px-2 tw-absolute tw-bottom-0;
}
.drop-shadow {
  box-shadow: 0 0 30px black;
}
.background-info {
  background: rgb(0, 0, 0);
  background: linear-gradient(-90deg, #031b41aa 0%, #031b41aa 100%);
  opacity: 1;
}
</style>
